$(function () {

    /*
     * Configuration
     */
    DECIX.setup = DECIX.setup || {};
    DECIX.setup = {};

    /*
     * Global functions
     */
    DECIX.functions = DECIX.functions || {};

    /*
     * Global dom references
     */
    DECIX.dom = DECIX.dom || {};

    DECIX.dom.$window = $(window);
    DECIX.dom.$document = $(document);
    DECIX.dom.$body = $("body");

    DECIX.dom.$siteHeader = $("#site-header");
    DECIX.dom.$siteBody = $("#site-body");
    DECIX.dom.$siteMenu = $("#site-menu");
    DECIX.dom.$siteFooter = $("#site-footer");

    DECIX.dom.$navigationPrimary = $(".navigation--primary");
    DECIX.dom.$navigationSecondary = $(".navigation--secondary");
    DECIX.dom.$navigationTertiary = $(".navigation--tertiary");

    /* *********************************************************************** */

    /*
     * Device and browser settings
     */
    DECIX.device = DECIX.device || {};

    /*
     * Detect browser
     */
    DECIX.device.browser = navigator.userAgent.toLowerCase();

    /*
     * Detect touch
     */
    DECIX.device.touch = "ontouchstart" in document.documentElement;

    /*
     * Detect device by Bootstrap grid sizes
     */
    DECIX.dom.$body
        .append("<div id=\"breakpoint-desktop\" class=\"visible-md visible-lg\" />")
        .append("<div id=\"breakpoint-tablet\" class=\"visible-sm\" />")
        .append("<div id=\"breakpoint-phone\" class=\"visible-xs\" />");

    DECIX.functions.detectDevice = function () {
        DECIX.device.wasDesktop = DECIX.device.isDesktop || false;
        DECIX.device.wasTablet = DECIX.device.isTablet || false;
        DECIX.device.wasPhone = DECIX.device.isPhone || false;

        DECIX.device.isDesktop = $("#breakpoint-desktop").is(":visible");
        DECIX.device.isTablet = $("#breakpoint-tablet").is(":visible");
        DECIX.device.isPhone = $("#breakpoint-phone").is(":visible");
    };

    /*
     * Switch position of secondary and primary navigation in mobile viewports,
     * so that the burger menu button is shown to the far right.
     */
    DECIX.functions.switchNavigationPositionsInDom = function () {
        if (DECIX.device.isPhone || DECIX.device.isTablet) {
            DECIX.dom.$navigationSecondary.detach();
            DECIX.dom.$navigationSecondary.insertAfter(DECIX.dom.$navigationPrimary);
        } else {
            DECIX.dom.$navigationSecondary.detach();
            DECIX.dom.$navigationSecondary.insertBefore(DECIX.dom.$navigationPrimary);
        }
    };

    /* Trigger functions */
    DECIX.functions.detectDevice();
    DECIX.functions.switchNavigationPositionsInDom();

    /* Register functions on resize */
    DECIX.dom.$window.on("resize", $.debounce(100, function () {
        DECIX.functions.detectDevice();
        DECIX.functions.switchNavigationPositionsInDom();
    }));

    /*
     * Function to get URI query parameter values
     */
    DECIX.functions.uriQueryValue = function (name) {
        var parameters = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);

        if (parameters === null) {
            return null;
        } else {
            return decodeURI(parameters[1]) || 0;
        }
    };

    /*
     * function to get URI anchor value
     */
    DECIX.functions.uriAnchorValue = function () {
        return window.location.hash.substr(1);
    };

});
